import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';

// Shared layout for all auth screens: brand logo + a centered card.
const AuthShell = ({ title, children, footer }) => (
  <div className="min-h-screen flex items-center justify-center p-5">
    <div className="w-full max-w-[400px] flex flex-col items-center gap-6">
      <img src="/swolepump-header.png" alt="SwolePump" className="w-64 max-w-[80%]" />
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-center text-xl">{title}</CardTitle>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
      {footer && <div className="text-sm text-muted-foreground text-center">{footer}</div>}
    </div>
  </div>
);

export default AuthShell;
